import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'edex-admin-container',
  templateUrl: './admin-container.component.html',
  styleUrls: ['./admin-container.component.scss']
})
export class AdminContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
